module.exports = __webpack_public_path__ + "img/img-ab303d94.9887a6df.png";